/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BillingOrderIndexResponse,
  ContentLearningEventOrderCancelResponse,
  ContentLearningEventOrderIndexResponse,
  ContentLearningEventOrderSettleResponse,
  ContentLearningEventOrderShowResponse,
  ContentLearningEventOrderUpdateResponse,
  DocumentInvoiceResponse,
  ExportJobStatusOrdersExportResponse,
  OrderUpdate,
} from '../models';
import {
    BillingOrderIndexResponseFromJSON,
    BillingOrderIndexResponseToJSON,
    ContentLearningEventOrderCancelResponseFromJSON,
    ContentLearningEventOrderCancelResponseToJSON,
    ContentLearningEventOrderIndexResponseFromJSON,
    ContentLearningEventOrderIndexResponseToJSON,
    ContentLearningEventOrderSettleResponseFromJSON,
    ContentLearningEventOrderSettleResponseToJSON,
    ContentLearningEventOrderShowResponseFromJSON,
    ContentLearningEventOrderShowResponseToJSON,
    ContentLearningEventOrderUpdateResponseFromJSON,
    ContentLearningEventOrderUpdateResponseToJSON,
    DocumentInvoiceResponseFromJSON,
    DocumentInvoiceResponseToJSON,
    ExportJobStatusOrdersExportResponseFromJSON,
    ExportJobStatusOrdersExportResponseToJSON,
    OrderUpdateFromJSON,
    OrderUpdateToJSON,
} from '../models';

export interface CompanySpacesLearningEventLearningEventIdOrdersGetRequest {
    learningEventId: number;
    paymentMethod?: string;
    internal?: boolean;
}

export interface CompanySpacesLearningEventLearningEventIdOrdersIdCancelPostRequest {
    learningEventId: number;
    id: string;
    body?: object;
}

export interface CompanySpacesLearningEventLearningEventIdOrdersIdGetRequest {
    learningEventId: number;
    id: string;
}

export interface CompanySpacesLearningEventLearningEventIdOrdersIdInvoiceGetRequest {
    learningEventId: number;
    id: string;
}

export interface CompanySpacesLearningEventLearningEventIdOrdersIdPutRequest {
    learningEventId: number;
    id: string;
    body?: OrderUpdate;
}

export interface CompanySpacesLearningEventLearningEventIdOrdersIdSettlePostRequest {
    learningEventId: number;
    id: string;
    body?: object;
}

export interface CompanySpacesOrdersExportGetRequest {
    startDate?: Date;
    endDate?: Date;
    period?: CompanySpacesOrdersExportGetPeriodEnum;
    states?: Array<CompanySpacesOrdersExportGetStatesEnum>;
    paymentMethods?: Array<CompanySpacesOrdersExportGetPaymentMethodsEnum>;
}

export interface CompanySpacesOrdersGetRequest {
    orderNumbers?: Array<string>;
    states?: Array<CompanySpacesOrdersGetStatesEnum>;
    paymentMethods?: Array<CompanySpacesOrdersGetPaymentMethodsEnum>;
    startDate?: Date;
    endDate?: Date;
    period?: CompanySpacesOrdersGetPeriodEnum;
    page?: number;
    perPage?: number;
}

/**
 * 
 */
export class OrderApi extends runtime.BaseAPI {

    /**
     */
    async companySpacesBillingOrdersGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BillingOrderIndexResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/billing/orders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BillingOrderIndexResponseFromJSON));
    }

    /**
     */
    async companySpacesBillingOrdersGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BillingOrderIndexResponse>> {
        const response = await this.companySpacesBillingOrdersGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdOrdersGetRaw(requestParameters: CompanySpacesLearningEventLearningEventIdOrdersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentLearningEventOrderIndexResponse>>> {
        if (requestParameters.learningEventId === null || requestParameters.learningEventId === undefined) {
            throw new runtime.RequiredError('learningEventId','Required parameter requestParameters.learningEventId was null or undefined when calling companySpacesLearningEventLearningEventIdOrdersGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.paymentMethod !== undefined) {
            queryParameters['payment_method'] = requestParameters.paymentMethod;
        }

        if (requestParameters.internal !== undefined) {
            queryParameters['internal'] = requestParameters.internal;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/learning_event/{learning_event_id}/orders`.replace(`{${"learning_event_id"}}`, encodeURIComponent(String(requestParameters.learningEventId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentLearningEventOrderIndexResponseFromJSON));
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdOrdersGet(requestParameters: CompanySpacesLearningEventLearningEventIdOrdersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentLearningEventOrderIndexResponse>> {
        const response = await this.companySpacesLearningEventLearningEventIdOrdersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdOrdersIdCancelPostRaw(requestParameters: CompanySpacesLearningEventLearningEventIdOrdersIdCancelPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentLearningEventOrderCancelResponse>> {
        if (requestParameters.learningEventId === null || requestParameters.learningEventId === undefined) {
            throw new runtime.RequiredError('learningEventId','Required parameter requestParameters.learningEventId was null or undefined when calling companySpacesLearningEventLearningEventIdOrdersIdCancelPost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesLearningEventLearningEventIdOrdersIdCancelPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/learning_event/{learning_event_id}/orders/{id}/cancel`.replace(`{${"learning_event_id"}}`, encodeURIComponent(String(requestParameters.learningEventId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentLearningEventOrderCancelResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdOrdersIdCancelPost(requestParameters: CompanySpacesLearningEventLearningEventIdOrdersIdCancelPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentLearningEventOrderCancelResponse> {
        const response = await this.companySpacesLearningEventLearningEventIdOrdersIdCancelPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdOrdersIdGetRaw(requestParameters: CompanySpacesLearningEventLearningEventIdOrdersIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentLearningEventOrderShowResponse>> {
        if (requestParameters.learningEventId === null || requestParameters.learningEventId === undefined) {
            throw new runtime.RequiredError('learningEventId','Required parameter requestParameters.learningEventId was null or undefined when calling companySpacesLearningEventLearningEventIdOrdersIdGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesLearningEventLearningEventIdOrdersIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/learning_event/{learning_event_id}/orders/{id}`.replace(`{${"learning_event_id"}}`, encodeURIComponent(String(requestParameters.learningEventId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentLearningEventOrderShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdOrdersIdGet(requestParameters: CompanySpacesLearningEventLearningEventIdOrdersIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentLearningEventOrderShowResponse> {
        const response = await this.companySpacesLearningEventLearningEventIdOrdersIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdOrdersIdInvoiceGetRaw(requestParameters: CompanySpacesLearningEventLearningEventIdOrdersIdInvoiceGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentInvoiceResponse>> {
        if (requestParameters.learningEventId === null || requestParameters.learningEventId === undefined) {
            throw new runtime.RequiredError('learningEventId','Required parameter requestParameters.learningEventId was null or undefined when calling companySpacesLearningEventLearningEventIdOrdersIdInvoiceGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesLearningEventLearningEventIdOrdersIdInvoiceGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/learning_event/{learning_event_id}/orders/{id}/invoice`.replace(`{${"learning_event_id"}}`, encodeURIComponent(String(requestParameters.learningEventId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentInvoiceResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdOrdersIdInvoiceGet(requestParameters: CompanySpacesLearningEventLearningEventIdOrdersIdInvoiceGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentInvoiceResponse> {
        const response = await this.companySpacesLearningEventLearningEventIdOrdersIdInvoiceGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdOrdersIdPutRaw(requestParameters: CompanySpacesLearningEventLearningEventIdOrdersIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentLearningEventOrderUpdateResponse>> {
        if (requestParameters.learningEventId === null || requestParameters.learningEventId === undefined) {
            throw new runtime.RequiredError('learningEventId','Required parameter requestParameters.learningEventId was null or undefined when calling companySpacesLearningEventLearningEventIdOrdersIdPut.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesLearningEventLearningEventIdOrdersIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/learning_event/{learning_event_id}/orders/{id}`.replace(`{${"learning_event_id"}}`, encodeURIComponent(String(requestParameters.learningEventId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrderUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentLearningEventOrderUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdOrdersIdPut(requestParameters: CompanySpacesLearningEventLearningEventIdOrdersIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentLearningEventOrderUpdateResponse> {
        const response = await this.companySpacesLearningEventLearningEventIdOrdersIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdOrdersIdSettlePostRaw(requestParameters: CompanySpacesLearningEventLearningEventIdOrdersIdSettlePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentLearningEventOrderSettleResponse>> {
        if (requestParameters.learningEventId === null || requestParameters.learningEventId === undefined) {
            throw new runtime.RequiredError('learningEventId','Required parameter requestParameters.learningEventId was null or undefined when calling companySpacesLearningEventLearningEventIdOrdersIdSettlePost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesLearningEventLearningEventIdOrdersIdSettlePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/learning_event/{learning_event_id}/orders/{id}/settle`.replace(`{${"learning_event_id"}}`, encodeURIComponent(String(requestParameters.learningEventId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentLearningEventOrderSettleResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdOrdersIdSettlePost(requestParameters: CompanySpacesLearningEventLearningEventIdOrdersIdSettlePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentLearningEventOrderSettleResponse> {
        const response = await this.companySpacesLearningEventLearningEventIdOrdersIdSettlePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesOrdersExportGetRaw(requestParameters: CompanySpacesOrdersExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExportJobStatusOrdersExportResponse>> {
        const queryParameters: any = {};

        if (requestParameters.startDate !== undefined) {
            queryParameters['start_date'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['end_date'] = (requestParameters.endDate as any).toISOString();
        }

        if (requestParameters.period !== undefined) {
            queryParameters['period'] = requestParameters.period;
        }

        if (requestParameters.states) {
            queryParameters['states'] = requestParameters.states.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.paymentMethods) {
            queryParameters['payment_methods'] = requestParameters.paymentMethods.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/orders/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExportJobStatusOrdersExportResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesOrdersExportGet(requestParameters: CompanySpacesOrdersExportGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExportJobStatusOrdersExportResponse> {
        const response = await this.companySpacesOrdersExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesOrdersGetRaw(requestParameters: CompanySpacesOrdersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BillingOrderIndexResponse>>> {
        const queryParameters: any = {};

        if (requestParameters.orderNumbers) {
            queryParameters['order_numbers'] = requestParameters.orderNumbers.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.states) {
            queryParameters['states'] = requestParameters.states.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.paymentMethods) {
            queryParameters['payment_methods'] = requestParameters.paymentMethods.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['start_date'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['end_date'] = (requestParameters.endDate as any).toISOString();
        }

        if (requestParameters.period !== undefined) {
            queryParameters['period'] = requestParameters.period;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/orders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BillingOrderIndexResponseFromJSON));
    }

    /**
     */
    async companySpacesOrdersGet(requestParameters: CompanySpacesOrdersGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BillingOrderIndexResponse>> {
        const response = await this.companySpacesOrdersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CompanySpacesOrdersExportGetPeriodEnum = {
    Year: 'year',
    Month: 'month'
} as const;
export type CompanySpacesOrdersExportGetPeriodEnum = typeof CompanySpacesOrdersExportGetPeriodEnum[keyof typeof CompanySpacesOrdersExportGetPeriodEnum];
/**
 * @export
 */
export const CompanySpacesOrdersExportGetStatesEnum = {
    Unsubmitted: 'unsubmitted',
    Pending: 'pending',
    Settled: 'settled',
    Failed: 'failed'
} as const;
export type CompanySpacesOrdersExportGetStatesEnum = typeof CompanySpacesOrdersExportGetStatesEnum[keyof typeof CompanySpacesOrdersExportGetStatesEnum];
/**
 * @export
 */
export const CompanySpacesOrdersExportGetPaymentMethodsEnum = {
    Gateway: 'gateway',
    BankTransfer: 'bank_transfer',
    Cash: 'cash',
    Code: 'code'
} as const;
export type CompanySpacesOrdersExportGetPaymentMethodsEnum = typeof CompanySpacesOrdersExportGetPaymentMethodsEnum[keyof typeof CompanySpacesOrdersExportGetPaymentMethodsEnum];
/**
 * @export
 */
export const CompanySpacesOrdersGetStatesEnum = {
    Unsubmitted: 'unsubmitted',
    Pending: 'pending',
    Settled: 'settled',
    Failed: 'failed'
} as const;
export type CompanySpacesOrdersGetStatesEnum = typeof CompanySpacesOrdersGetStatesEnum[keyof typeof CompanySpacesOrdersGetStatesEnum];
/**
 * @export
 */
export const CompanySpacesOrdersGetPaymentMethodsEnum = {
    Gateway: 'gateway',
    BankTransfer: 'bank_transfer',
    Cash: 'cash',
    Code: 'code'
} as const;
export type CompanySpacesOrdersGetPaymentMethodsEnum = typeof CompanySpacesOrdersGetPaymentMethodsEnum[keyof typeof CompanySpacesOrdersGetPaymentMethodsEnum];
/**
 * @export
 */
export const CompanySpacesOrdersGetPeriodEnum = {
    Year: 'year',
    Month: 'month'
} as const;
export type CompanySpacesOrdersGetPeriodEnum = typeof CompanySpacesOrdersGetPeriodEnum[keyof typeof CompanySpacesOrdersGetPeriodEnum];
